import React, { Component } from "react";
import { Modal } from "react-bootstrap";
import { connect } from "react-redux";
import * as actionCreators from "../../../action/index.js";
import { updateAlertMessage } from "../../../helpers/common/helperConstant.js";
import { editUserAddress } from "../../../action/quote_order/leadcustomer.action.js";

class ConfirmationBox extends React.Component {
  handleClose = (e, confirmation) => {
    let confirm = confirmation === true ? "delete" : "";
    this.props.editUserAddress(e, "Remove", "removeAddress", "", confirm);
  };

  render() {
    return (
      <div>
        <Modal
          centered
          show={this.props.confirmationBoxShow}
          dialogClassName="new-alert-modal react-modal"
          backdrop="static"
          // keyboard={false}
          onHide={(e) => this.handleClose(e)}
        >
          <button className={"close"} onClick={(e) => this.handleClose(e)}>
            <span className="icon-close"></span>
          </button>
          <Modal.Body>
            <h5 className="modal-title mb-3">Delete Confirmation</h5>

            <div className="row">
              <div className="col-12">
                <p>{"Do you really want to delete this address."}</p>
              </div>
            </div>

            <div className="alert-footer">
              <button
                onClick={(e) => this.handleClose(e)}
                className={"btn btn-default"}
              >
                <span className="text ">Cancel</span>
              </button>

              <button
                onClick={(e) => this.handleClose(e, true)}
                className="btn btn-primary"
              >
                <span className="text">Delete</span>
              </button>
            </div>
          </Modal.Body>
        </Modal>
      </div>
    );
  }
}

const mapStoreToProps = (state) => {
  return state.leadcustomerReducer;
};

const mapDispatchToProps = {
  editUserAddress,
};

export default connect(mapStoreToProps, mapDispatchToProps)(ConfirmationBox);
